import { render, staticRenderFns } from "./ScoreTag.vue?vue&type=template&id=64452b90"
import script from "./ScoreTag.vue?vue&type=script&lang=js"
export * from "./ScoreTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports